export const CONTACT_PHONE = '93 517 12 02'